import { normalizeMessages } from './messageNormalize'

export function getNextQueryVersionIndex(messagesByThreadId, tid, exchangeId) {
  const list = normalizeMessages(messagesByThreadId[tid] ?? [])
  let max = -1
  for (const m of list) {
    if (m.exchangeId !== exchangeId) continue
    if (m.role !== 'user') continue
    if (typeof m.versionIndex === 'number') max = Math.max(max, m.versionIndex)
  }
  return max + 1
}

export function getNextAssistantVersionIndex(messagesByThreadId, tid, exchangeId, versionIndex) {
  const list = normalizeMessages(messagesByThreadId[tid] ?? [])
  let max = -1
  for (const m of list) {
    if (m.exchangeId !== exchangeId) continue
    if (m.role !== 'assistant') continue
    if (typeof m.versionIndex === 'number' && m.versionIndex !== versionIndex) continue
    if (typeof m.assistantVersionIndex === 'number') max = Math.max(max, m.assistantVersionIndex)
  }
  return max + 1
}
